import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "content__container" }
const _hoisted_2 = { class: "content__title" }
const _hoisted_3 = { class: "order-status" }
const _hoisted_4 = { class: "error-reason" }

import EzTable from '@/corePagesModule/components/ezTable/EzTable.vue';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';
import { i18n } from '@/i18n';
import { ERROR_REASON_LABELS, TABLE_HEADERS } from '../constants';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { storeToRefs } from 'pinia';
import { useUnmatchedOrderStore } from '../pages/useUnmatchedOrderStore';
import { computed } from 'vue';
import EzHeader from '@/corePagesModule/components/ezTable/EzHeader.vue';
import EzTableRow from '@/corePagesModule/components/ezTable/EzTableRow.vue';
import EzCell from '@/corePagesModule/components/ezTable/EzCell.vue';
import OrderStatusBadge from '@/corePagesModule/components/OrderStatusBadge.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'BulkRegisterModal',
  setup(__props) {

const t = i18n.t;
const store = useUnmatchedOrderStore();
const { state } = storeToRefs(store);
const { bulkRegisterOrderBusinesses } = store;

const displayHeaders = computed(() => TABLE_HEADERS.slice(1, -1));
const displayItems = computed(() => state.value.items.filter((i) => state.value.checkedIds.includes(i.unmatchedOrderId)));

/**
 * キャンセルボタンを押した際の処理
 */
const onBack = () => {
  state.value.bulkRegisterModalState = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InfoModal, {
    "modal-state": _unref(state).bulkRegisterModalState,
    "modal-width": 1300,
    "back-button-label": _unref(t)('キャンセル'),
    "next-button-label": _unref(t)('登録'),
    onOnBack: onBack,
    onOnNext: _unref(bulkRegisterOrderBusinesses)
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('発注一括登録')), 1)
    ]),
    description: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('未照合発注を一括で発注登録します。')) + " " + _toDisplayString(_unref(t)('なお、必須事項を満たしていないものや、重複しているものなどは自動的に除外されます。')), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('登録する未照合発注一覧')), 1),
        _createVNode(EzTable, {
          "grid-template-columns": displayHeaders.value.map((h) => h.width),
          "sticky-header": "",
          "max-height": "calc(100vh - 600px)"
        }, {
          header: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayHeaders.value, (header) => {
              return (_openBlock(), _createBlock(EzHeader, {
                key: `header:${header.key}`
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)(header.label)), 1)
                ], undefined, true),
                _: 2
              }, 1024))
            }), 128))
          ]),
          body: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayItems.value, (item, index) => {
              return (_openBlock(), _createBlock(EzTableRow, {
                key: item.unmatchedOrderId,
                "grid-template-columns": displayHeaders.value.map((h) => h.width),
                class: "unmatched-row"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayHeaders.value, (header) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: `row:${header.key}:${index}`
                    }, [
                      (header.key === 'orderStatus')
                        ? (_openBlock(), _createBlock(EzCell, {
                            key: 0,
                            "force-center": ""
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_3, [
                                _createVNode(OrderStatusBadge, {
                                  "order-status-str": item.orderStatus
                                }, null, 8, ["order-status-str"])
                              ])
                            ], undefined, true),
                            _: 2
                          }, 1024))
                        : (header.key === 'errorReason')
                          ? (_openBlock(), _createBlock(EzCell, { key: 1 }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)(_unref(ERROR_REASON_LABELS)[item.errorReason] ?? _unref(ERROR_REASON_LABELS).unknown)), 1)
                              ], undefined, true),
                              _: 2
                            }, 1024))
                          : (header.type === 'num')
                            ? (_openBlock(), _createBlock(EzCell, {
                                key: 2,
                                "is-number": ""
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item[header.key]?.toLocaleString() ?? ''), 1)
                                ], undefined, true),
                                _: 2
                              }, 1024))
                            : (header.type === 'date')
                              ? (_openBlock(), _createBlock(EzCell, {
                                  key: 3,
                                  "is-number": ""
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item[header.key] ? _unref(DateService).convertMSUnixTimeToYYYYMMDDSlash(item[header.key]) : ''), 1)
                                  ], undefined, true),
                                  _: 2
                                }, 1024))
                              : (header.type === 'str')
                                ? (_openBlock(), _createBlock(EzCell, {
                                    key: 4,
                                    "is-number": ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item[header.key] ?? ''), 1)
                                    ], undefined, true),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ], undefined, true),
                _: 2
              }, 1032, ["grid-template-columns"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["grid-template-columns"])
      ])
    ]),
    _: 1
  }, 8, ["modal-state", "back-button-label", "next-button-label", "onOnNext"]))
}
}

})